import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הלחץ",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב ללחץ להיות מושלם/ת.",
      "רק לראות אותו.",
      "אני כאן."
    ],
      [
      "היום אני שם/ה לב ללחץ להיות מושלם/ת.",
      "רק לראות אותו.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הלחץ להיות מושלם הכי חזק?",
      "מה אני מפחד/ת שיקרה אם זה לא מושלם?",
      "איפה זה יושב בגוף?"
    ],
      [
      "איפה הלחץ להיות מושלם הכי חזק?",
      "מה אני מפחד/ת שיקרה אם זה לא מושלם?",
      "איפה זה יושב בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הלחץ הוא חוויה, לא זהות."
    ],
      [
      "הלחץ הוא חוויה, לא זהות."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני לא רוצה/ת להיות מושלם/ת\".",
      "נשימה אחת + \"אני לא רוצה/ת להיות מושלם/ת\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הקול בפנים",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לקול שמבקש שלמות.",
      "בלי להילחם.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מקשיב/ה לקול שמבקש שלמות.",
      "בלי להילחם.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הקול אומר לי כשזה לא מושלם?",
      "אילו מילים חוזרות?",
      "איך זה גורם לי להרגיש?"
    ],
      [
      "מה הקול אומר לי כשזה לא מושלם?",
      "אילו מילים חוזרות?",
      "איך זה גורם לי להרגיש?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הקול הוא קול, לא אמת מוחלטת."
    ],
      [
      "הקול הוא קול, לא אמת מוחלטת."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד - \"זה קול, לא אני\".",
      "משפט אחד - \"זה קול, לא אני\"."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הפחד שמתחת",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בפחד שמתחת לשלמות.",
      "בעדינות.",
      "אני כאן."
    ],
      [
      "היום אני נוגע/ת בפחד שמתחת לשלמות.",
      "בעדינות.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לחזה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לחזה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני מפחד/ת אם זה לא מושלם?",
      "איזה ערך אני מנסה להגן עליו?",
      "מה אני בוחר/ת/ה לשמוע כאן?"
    ],
      [
      "ממה אני מפחד/ת אם זה לא מושלם?",
      "איזה ערך אני מנסה להגן עליו?",
      "מה אני בוחר/ת/ה לשמוע כאן?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הפחד מבקש ביטחון, לא שלמות."
    ],
      [
      "הפחד מבקש ביטחון, לא שלמות."
    ]
    ),
    action: localizedGenderNode(
      "לומר בלב \"אני בטוח/ה מספיק\" פעם אחת.",
      "לומר בלב \"אני בטוח/ה מספיק\" פעם אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "עובדה מול פרשנות",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין מה שקרה לבין מה שאני מפרש/ת.",
      "בעדינות.",
      "אני כאן."
    ],
      [
      "היום אני מפריד/ה בין מה שקרה לבין מה שאני מפרש/ת.",
      "בעדינות.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדה הפשוטה כאן?",
      "איזה סיפור קופץ לי?",
      "איזו אפשרות עדינה יכולה גם להיות נכונה?"
    ],
      [
      "מה העובדה הפשוטה כאן?",
      "איזה סיפור קופץ לי?",
      "איזו אפשרות עדינה יכולה גם להיות נכונה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "פרשנות היא לא חובה."
    ],
      [
      "פרשנות היא לא חובה."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זו פרשנות\".",
      "משפט פנימי - \"זו פרשנות\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "המחיר",
    opening: localizedGenderNode(
      [
      "היום אני רואה את המחיר של שלמות.",
      "בלי להעניש.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני רואה את המחיר של שלמות.",
      "בלי להעניש.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת מעט את הכתפיים.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת מעט את הכתפיים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה השלמות לוקחת ממני?",
      "איפה אני מתעייף/ת?",
      "מה הייתי רוצה להקל בו?"
    ],
      [
      "מה השלמות לוקחת ממני?",
      "איפה אני מתעייף/ת?",
      "מה הייתי רוצה להקל בו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לראות את המחיר זה צעד עדין."
    ],
      [
      "לראות את המחיר זה צעד עדין."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב דבר אחד שאני מקל בו היום.",
      "לכתוב דבר אחד שאני מקל בו היום."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "טריגרים",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מה מפעיל את הצורך להיות מושלם/ת.",
      "רק מזהה.",
      "אני כאן."
    ],
      [
      "היום אני מזהה מה מפעיל את הצורך להיות מושלם/ת.",
      "רק מזהה.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי זה נדלק הכי חזק?",
      "איזה מצב או אדם מפעיל אותי?",
      "מה אני בוחר/ת/ה ברגע הזה?"
    ],
      [
      "מתי זה נדלק הכי חזק?",
      "איזה מצב או אדם מפעיל אותי?",
      "מה אני בוחר/ת/ה ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשאני מזהה טריגר, יש לי מרווח קטן."
    ],
      [
      "כשאני מזהה טריגר, יש לי מרווח קטן."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה כשזה עולה.",
      "יד על החזה כשזה עולה."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "גבול עדין",
    opening: localizedGenderNode(
      [
      "היום אני מציב/ה גבול עדין לשלמות.",
      "לא מלחמה.",
      "אני כאן."
    ],
      [
      "היום אני מציב/ה גבול עדין לשלמות.",
      "לא מלחמה.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני יכול/ה להוריד 10%?",
      "מה יקרה אם זה יהיה מספיק טוב?",
      "איזה גבול קטן יעזור לי היום?"
    ],
      [
      "איפה אני יכול/ה להוריד 10%?",
      "מה יקרה אם זה יהיה מספיק טוב?",
      "איזה גבול קטן יעזור לי היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול קטן יוצר מרווח לנשימה."
    ],
      [
      "גבול קטן יוצר מרווח לנשימה."
    ]
    ),
    action: localizedGenderNode(
      "לומר \"מספיק טוב\" פעם אחת.",
      "לומר \"מספיק טוב\" פעם אחת."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "חמלה קטנה",
    opening: localizedGenderNode(
      [
      "היום אני מנסה לדבר אליי ברוך.",
      "גם אם זה חדש.",
      "אני כאן."
    ],
      [
      "היום אני מנסה לדבר אליי ברוך.",
      "גם אם זה חדש.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הייתי מדבר/ת לחבר/ה כאן?",
      "איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "מה משתנה בי כשאני שומע/ת אותו?"
    ],
      [
      "איך הייתי מדבר/ת לחבר/ה כאן?",
      "איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "מה משתנה בי כשאני שומע/ת אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מילה רכה אחת מספיקה להתחלה."
    ],
      [
      "מילה רכה אחת מספיקה להתחלה."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך אחד לעצמי.",
      "משפט רך אחד לעצמי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "להיות מספיק",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת ברעיון של \"מספיק\".",
      "בלי לדחוף.",
      "אני כאן."
    ],
      [
      "היום אני נוגע/ת ברעיון של \"מספיק\".",
      "בלי לדחוף.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שומע/ת את הנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שומע/ת את הנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה נראה לי \"מספיק\" היום?",
      "איך זה מרגיש אם אני נותן/ת לזה מקום?",
      "מה אני מרוויח/ה מזה?"
    ],
      [
      "מה נראה לי \"מספיק\" היום?",
      "איך זה מרגיש אם אני נותן/ת לזה מקום?",
      "מה אני מרוויח/ה מזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מספיק הוא חוויה חדשה שאני לומד/ת."
    ],
      [
      "מספיק הוא חוויה חדשה שאני לומד/ת."
    ]
    ),
    action: localizedGenderNode(
      "לבחור דבר אחד שיהיה מספיק.",
      "לבחור דבר אחד שיהיה מספיק."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הבקשה הכי חשובה לי עכשיו?",
      "איך אני אומר/ת אותה במשפט אחד?",
      "מה אני מוכן/ה לתת לעצמי בתמורה?"
    ],
      [
      "מה הבקשה הכי חשובה לי עכשיו?",
      "איך אני אומר/ת אותה במשפט אחד?",
      "מה אני מוכן/ה לתת לעצמי בתמורה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לרכך את היום."
    ],
      [
      "בקשה אחת יכולה לרכך את היום."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט קצר.",
      "לכתוב את הבקשה במשפט קצר."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "שינוי קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת שינוי קטן בלב היום.",
      "לא מהפכה.",
      "אני כאן."
    ],
      [
      "היום אני בוחר/ת שינוי קטן בלב היום.",
      "לא מהפכה.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנקודת מגע אחת בגוף.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנקודת מגע אחת בגוף.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה שינוי קטן שאני מוכן/ה לנסות היום?",
      "מתי הכי קל לי לנסות אותו?",
      "מה יזכיר לי בעדינות לבחור בו?"
    ],
      [
      "מה שינוי קטן שאני מוכן/ה לנסות היום?",
      "מתי הכי קל לי לנסות אותו?",
      "מה יזכיר לי בעדינות לבחור בו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "שינוי קטן הוא תנועה עדינה."
    ],
      [
      "שינוי קטן הוא תנועה עדינה."
    ]
    ),
    action: localizedGenderNode(
      "לבחור רגע אחד לנסות.",
      "לבחור רגע אחד לנסות."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "להיות אנושי/ת",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת מקום ללהיות אנושי/ת.",
      "בלי לבטל.",
      "אני כאן."
    ],
      [
      "היום אני נותן/ת מקום ללהיות אנושי/ת.",
      "בלי לבטל.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה היה קורה אם הייתי מרשה לעצמי להיות אנושי/ת?",
      "מה זה היה משחרר בי?",
      "איזו עדינות אני יכול/ה לתת לעצמי?"
    ],
      [
      "מה היה קורה אם הייתי מרשה לעצמי להיות אנושי/ת?",
      "מה זה היה משחרר בי?",
      "איזו עדינות אני יכול/ה לתת לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להיות אנושי/ת זה לא כישלון."
    ],
      [
      "להיות אנושי/ת זה לא כישלון."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד של רשות לעצמי.",
      "משפט אחד של רשות לעצמי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "תרגול קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת תרגול קטן שמרכך שלמות.",
      "פשוט.",
      "אני כאן."
    ],
      [
      "היום אני בוחר/ת תרגול קטן שמרכך שלמות.",
      "פשוט.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה תרגול קטן יכול לעזור לי היום?",
      "מתי ביום אני עושה אותו?",
      "מה יזכיר לי בעדינות?"
    ],
      [
      "איזה תרגול קטן יכול לעזור לי היום?",
      "מתי ביום אני עושה אותו?",
      "מה יזכיר לי בעדינות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "תרגול קטן יוצר שינוי עדין."
    ],
      [
      "תרגול קטן יוצר שינוי עדין."
    ]
    ),
    action: localizedGenderNode(
      "לבחור רגע אחד לתרגול.",
      "לבחור רגע אחד לתרגול."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת את המסע ברוך.",
      "בלי לכפות סיום מושלם.",
      "אני כאן."
    ],
      [
      "היום אני מסיים/ת את המסע ברוך.",
      "בלי לכפות סיום מושלם.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על השלמות שלי?",
      "מה הסימן המוקדם שאני חוזר/ת ללחץ?",
      "משפט חזרה לרגע לפני - מה אני אומר/ת לעצמי?"
    ],
      [
      "מה למדתי על השלמות שלי?",
      "מה הסימן המוקדם שאני חוזר/ת ללחץ?",
      "משפט חזרה לרגע לפני - מה אני אומר/ת לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה להיות מדויק/ת בלי מושלם/ת."
    ],
      [
      "אני יכול/ה להיות מדויק/ת בלי מושלם/ת."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת לפני תגובה.",
      "נשימה אחת לפני תגובה."
    ),
  },
].map(buildNormalizedDay);

export const needToBePerfectInEverythingBlueprintHe = buildNormalizedPilotBlueprint({
  id: "need_to_be_perfect_in_everything_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "need_to_be_perfect_in_everything",
  category: "self_worth",
  journeyName: {
    he: "פרפקציוניזם (יכול להיות מושלם בהכל)",
    en: "Need to be perfect in everything",
    es: "Necesidad de ser perfecto/a en todo",
  },
  days,
});

export default needToBePerfectInEverythingBlueprintHe;
